/**
 * Telling "the platform is unreachable" apart from "the platform has a bug".
 *
 * Its own module, with no React and no MUI, so it can be tested directly: the
 * unit runner here is configured for a node environment, and anything importing
 * a component pulls in i18n and the browser globals with it.
 *
 * The distinction earns its place because the two failures ask different things
 * of the member. Waiting and retrying fixes an unreachable API and never fixes a
 * defect, so telling someone to retry a bug wastes their time and teaches them
 * to ignore the message the next time it appears.
 */

import axios from 'axios';

export const isConnectivityError = (error: unknown): boolean => {
  if (axios.isAxiosError(error)) {
    // No response at all is a request that never arrived -- a dead host, a
    // blocked CORS preflight, a dropped connection. A 5xx did arrive, but from
    // a platform that could not answer it, which is the same thing to a member.
    return error.response === undefined || error.response.status >= 500;
  }
  // What is left once axios is out of the picture: fetch rejects with a
  // TypeError carrying no status anywhere.
  return (
    error instanceof TypeError && /fetch|network|load failed/i.test(error.message)
  );
};
